"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoIconSmall = InfoIconSmall;
exports.default = InfoIcon;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("./shared/icon-base"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function InfoIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    d: "M13 17.5V12H11V17.5H13Z",
    fill: "currentColor"
  }), (0, _core.jsx)("path", {
    d: "M12 7.5C11.1716 7.5 10.5 8.17163 10.5 9C10.5 9.82837 11.1716 10.5 12 10.5C12.8284 10.5 13.5 9.82837 13.5 9C13.5 8.17163 12.8284 7.5 12 7.5Z",
    fill: "currentColor"
  }), (0, _core.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5Z",
    fill: "currentColor"
  }));
}
function InfoIconSmall(props) {
  return (0, _core.jsx)(InfoIcon, _extends({
    size: "small"
  }, props));
}